import React, { useState } from "react";
import { StyleSheet, Text } from "react-native";

import { sandboxOn, useDevSession } from "../../dev/devSession";
import { devPanelEnabledHere } from "../../dev/gating";
import { DEV_COLOR } from "./devStyles";

/** Header badge while the dev panel is available: "DEV", plus "sandbox" when on. */
const DevBadge: React.FC = () => {
  const [enabled] = useState(devPanelEnabledHere);
  const sandbox = useDevSession(sandboxOn);
  if (!enabled) return null;
  return (
    <Text testID="dev-badge" style={styles.badge}>
      {sandbox ? "DEV · sandbox" : "DEV"}
    </Text>
  );
};

const styles = StyleSheet.create({
  badge: {
    marginLeft: 8,
    paddingHorizontal: 5,
    paddingVertical: 1,
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: DEV_COLOR,
    color: DEV_COLOR,
    fontSize: 10,
    fontWeight: "700",
  },
});

export default DevBadge;
